import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Check, CheckCheck } from "lucide-react";
import api from "../../lib/api";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
} from "../ui/dropdown-menu";
import { toast } from "sonner";

const fmt = (iso) => { try { const d = new Date(iso); return d.toLocaleString(); } catch { return iso; } };

export const NotificationsBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try { const { data } = await api.get("/notifications/mine"); setItems(data.items || []); setUnread(data.unread || 0); }
    catch {}
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const markRead = async (id) => {
    try { await api.post(`/notifications/${id}/read`); load(); } catch {}
  };
  const readAll = async () => {
    try { await api.post("/notifications/read-all"); load(); toast.success("Marked all as read"); } catch {}
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="notifications-btn" className="relative w-9 h-9 rounded-md border flex items-center justify-center hover:bg-white/5 transition-colors duration-200"
                style={{ borderColor: "var(--border-strong)", background: "var(--surface)" }}>
          <Bell size={14} className="text-zinc-300"/>
          {unread > 0 && (
            <span data-testid="notifications-badge" className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-mono flex items-center justify-center text-white"
                  style={{ background: "#3B82F6", border: "1px solid var(--surface)" }}>
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-96 p-0" style={{ background: "var(--surface)", borderColor: "var(--border-strong)", color: "var(--text)" }}>
        <div className="px-4 py-3 border-b flex items-center gap-2" style={{ borderColor: "var(--border)" }}>
          <div className="text-sm font-medium">Notifications</div>
          <span className="text-[10px] text-zinc-500">{unread} unread</span>
          <button data-testid="notifications-readall-btn" onClick={readAll} className="ml-auto text-[11px] text-blue-400 hover:text-blue-300 inline-flex items-center gap-1 transition-colors duration-200">
            <CheckCheck size={11}/> Mark all read
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-6 text-center text-xs text-zinc-500">No notifications yet.</div>
          ) : items.slice(0, 20).map(n => (
            <div key={n.notification_id} data-testid={`notif-${n.notification_id}`}
                 className={`p-3 border-b flex gap-3 transition-colors duration-200 ${n.read ? "opacity-60" : "hover:bg-white/[0.03]"}`}
                 style={{ borderColor: "var(--border)" }}>
              <div className="w-1 rounded-full self-stretch" style={{ background: n.read ? "transparent" : "#3B82F6" }}/>
              <div className="flex-1 min-w-0">
                <div className="text-xs text-zinc-200 font-medium">{n.title}</div>
                {n.body && <div className="text-[11px] text-zinc-500 mt-1 leading-relaxed">{n.body}</div>}
                <div className="text-[10px] font-mono text-zinc-500 mt-1">{fmt(n.created_at)}</div>
              </div>
              {!n.read && (
                <button data-testid={`notif-read-${n.notification_id}`} onClick={() => markRead(n.notification_id)}
                        className="w-7 h-7 rounded-md border flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/5"
                        style={{ borderColor: "var(--border-strong)" }}><Check size={11}/></button>
              )}
            </div>
          ))}
        </div>
        <div className="px-4 py-2 border-t text-center" style={{ borderColor: "var(--border)" }}>
          <Link to="/notifications" className="text-[11px] text-blue-400 hover:text-blue-300 transition-colors duration-200">View all</Link>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NotificationsBell;
